import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { RadioButton } from "@similarweb/ui-components";

export const StyledCrmEnrichmentFilterRadioContainer = styled.div<{ isSelected: boolean }>`
    margin: 8px 0 4px;
    padding: 8px 0;
    border: ${({ isSelected }) => `1px solid ${isSelected ? colorsPalettes.blue[400] : colorsPalettes.carbon[100]}`};
    border-radius: 4px;
`;

export const StyledCrmEnrichmentFilterRadioButton = styled(RadioButton)`
    padding: 9px 10px;
    width: 100%;
`;

export const StyledCrmEnrichmentFilterAddIconButton = styled.div`
    width: fit-content;
    margin-left: 20px;
`;

export const StyledCrmEnrichmentFilterRadioLabel = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    color: ${colorsPalettes.carbon[300]};
`;
